module.exports = __webpack_public_path__ + "media/apps/bades-both-28447e7e.svg";